import { bl_inv_stock_replenishment_event_hdr_RowClass } from '../../../dbschema/bl_inv_stock_replenishment_event_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class StockReplenishmentEventHdrModel extends BaseContainerModel {
  bl_inv_stock_replenishment_event_hdr: bl_inv_stock_replenishment_event_hdr_RowClass = new bl_inv_stock_replenishment_event_hdr_RowClass();
}
